// extracted by mini-css-extract-plugin
export default {"header":"nav_header__lZ9tD"};